/**
 * Single source of truth for top-level pages: URL path, bottom-nav label/icon,
 * header title, the config feature flag that enables the page, and the desktop
 * sidebar section (`hideInNav` only hides a page from the mobile bottom nav).
 */
export const ROUTES = [
  { id: "dashboard", path: "/", label: "Home", icon: "🏠", title: null, featureKey: null, section: "Overview" },
  { id: "items", path: "/items", label: "Items", icon: "📦", title: "Items (Goods & Services)", featureKey: "items", section: "Inventory" },
  { id: "invoices", path: "/invoices", label: "Sales", icon: "🧾", title: "Sales Invoices", featureKey: "invoices", section: "Sales" },
  { id: "purchases", path: "/purchases", label: "Purchases", icon: "🛒", title: "Vendor Purchases", featureKey: "purchases", section: "Purchases" },
  { id: "customers", path: "/customers", label: "Parties", icon: "👥", title: "Customer & Vendor Directory", featureKey: "customers", section: "Sales" },
  { id: "inventory", path: "/inventory", label: "Stock", icon: "📊", title: "Stock & Movement", featureKey: "inventory", section: "Inventory" },
  { id: "banking", path: "/banking", label: "Banking", icon: "🏦", title: "Bank Accounts", featureKey: null, hideInNav: true, section: "Finance & Admin" },
  { id: "settings", path: "/settings", label: "Settings", icon: "⚙️", title: "Settings", featureKey: null, hideInNav: true, section: "Finance & Admin" }
];

/** Desktop sidebar section order. */
export const NAV_SECTIONS = ["Overview", "Sales", "Purchases", "Inventory", "Finance & Admin"];

/** Whether a page is enabled by the customer config's feature flags. */
export function isRouteEnabled(route, features = {}) {
  return !route.featureKey || features[route.featureKey] !== false;
}

/** Legacy tab id (e.g. "invoices") → URL path. */
export function pathForTab(tabId) {
  return ROUTES.find((r) => r.id === tabId)?.path || "/";
}

/** Route entry for a pathname, matched on its first segment ("/invoices/abc" → invoices). */
export function routeForPath(pathname = "/") {
  const segment = pathname.split("/").filter(Boolean)[0];
  if (!segment) return ROUTES[0];
  return ROUTES.find((r) => r.path === `/${segment}`) || null;
}
